<template>
  <section class="news-container">
    <div class="content-container">
      <div class="filter-container">
        <div class="filter-list">
          <v-date-picker
            v-model="date"
            :format="'dd-MM-yyyy HH:mm:ss'"
            :valueFormat="'yyyy-MM-dd HH:mm:ss'"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            @change="filterData"/>
        </div>
        <div class="btn">
          <v-button
            gray
            :disabled="date.length == 0"
            @click="handleExport">Export</v-button>
        </div>
      </div>

      <div class="transparent">
        <el-table
          :data="policyList"
          style="width: 100%"
          header-row-class-name="headerClass">
          <el-table-column
            width="120"
            label="Date">
            <template slot-scope="scope">
              <p>
                {{handlerTime(scope.row.created_at)[0]}}
              </p>
              <p>
                {{handlerTime(scope.row.created_at)[1]}}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            min-width="200"
            prop="order_sn"
            label="Policy Ref #" >
          </el-table-column>
          <el-table-column
            width="150"
            prop="role_nm"
            label="Role" >
          </el-table-column>
          <el-table-column
            min-width="120"
            label="Name"
            prop="agent">
          </el-table-column>
          <el-table-column
            min-width="160"
            label="Actions"
            prop="title">
          </el-table-column>
          <el-table-column
            min-width="180"
            label="Description"
            prop="message">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination
      layout="sizes"
      :page-sizes="pageConfig.sizes"
      :total="pageConfig.total"
      @size-change="sizeChange"
    />

  </section>
</template>
<script>

import MixinOptions from '@/mixins/options'
import { getPolicyLogList } from '@/api/admin-cms'
import {downloadFile} from '@/utils/download'
export default {
  name: 'smsLog',
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        size: 100,
        sizes: [100, 200, 500, 1000],
        currentPage: 1,
        total: 10
      },
      policyList: [],
      date: [],
      export: false
    }
  },
  computed: {

  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getPolicyLogList()
      }
    },
  },
  methods: {
    handlerTime(time){
      return time = time?time.split(' '):['-','-']
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getPolicyLogList()
    },
    sizeChange(size) {
      this.pageConfig.size = size
      this.network().getPolicyLogList()
    },
    handleExport(){
      this.export = true
      this.network().getPolicyLogList()
    },
    network() {
      return {
        getPolicyLogList: async () => {
          if(this.date == null){
            this.date = []
          }
          let params = {
            page: this.pageConfig.currentPage,
            total_limit: this.pageConfig.size,
            created_start: this.date.length > 0? this.date[0] : '',
            created_end: this.date.length > 0? this.date[1] : '',
            is_export: this.export? 1 : 0,
          }
          if(this.export){
            const res = await getPolicyLogList(params, {
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
            this.export = false
          }else{
            const { data } = await getPolicyLogList(params)
            this.policyList = data
          }
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .content-container {
    position: relative;
    .el-table {
      margin-top: 15px;
      border:1px solid #E1E4E8;
      border-radius: 4px;
      /deep/.headerClass{
        background:#F6F8FA;
        th{
          background:#F6F8FA;
          .cell{
            padding: 16px 10px;
            font-size: 14px;
            color: #24292E;
          }
        }
      }
    }
    .btn-list {
      text-align: center;
      span {
        margin-right: 10px;
      }
    }
    .filter-container {
      display: flex;
      justify-content: space-between;
      .filter-list {
        display: flex;
        justify-content: space-between;
      .el-input{
        margin: 0 20px;
      }
      }
    }
  }
  .dialog-container {
    padding: 15px;
  }
  .ic-order {
    .svg-inline--fa {
      color: #91939A;
      font-size: 12px;
    }
  }
  .img-banner {
    width: 150px;
  }
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      min-height: 24px;
    }
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
    }
    .font-weight{
      font-weight: 500;
    }
    .content-break{
      word-break: break-word;
    }
  }
  .fail{
    color: #CB2431;
  }
}
.el-pagination{
  margin-top: 20px;
  text-align: center;
}
</style>